<style lang="css">
  .finance-account-search-box {
    position: absolute;
    right: 20px;
    top: 8px;
    height: 36px;
    overflow: hidden;
  }

  .finance-account-search-box .vxe-input--inner {
    border: 1px solid #dcdfe6;
  }
</style>
<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li v-if="(isCollection && field === 'paymentsName') || (!isCollection && field === 'paymentsName') || (!isCollection && field === 'recName' && initObj.paymentsType === 0)">
            <vxe-radio name="xtabs" label="tab1">选择平台账户</vxe-radio>
          </li>
          <li v-if="!(isCollection && this.field === 'paymentsName')">
            <vxe-radio name="xtabs" label="tab2">选择客户账户</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="finance-account-search-box" style="display: flex;align-items: center">
<!--        <vxe-input-->
<!--            style="height: 34px !important; margin-right: 5px; width: 180px"-->
<!--            v-model="clientname"-->
<!--            type="text"-->
<!--            placeholder="搜索客户名称"-->
<!--            clearable-->
<!--            v-show="selectTab === 'tab2'"-->
<!--        ></vxe-input>-->
        <vxe-input
            style="height: 34px !important; width: 180px"
            v-model="username"
            type="text"
            placeholder="搜索户名"
            clearable
        ></vxe-input>
        <Button type="primary" icon="ios-search" @click="oSearch" style="margin-left: 10px;border-radius: 4px;">搜索
        </Button>
        <!--        <Button-->
        <!--          type="primary"-->
        <!--          icon="ios-add"-->
        <!--          @click="createUser"-->
        <!--          class="search-right-btn"-->
        <!--          v-show="selectTab === 'tab2' && account && !account.aboutCompId"-->
        <!--          >开通子账户-->
        <!--        </Button>-->
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          :loading="loading"
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable1"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="companyData"
          @current-change="currentChangeEvent1"
      >
        <vxe-table-column field="busiSubjectName" title="所属公司"></vxe-table-column>
        <vxe-table-column field="memName" title="子账户户名"></vxe-table-column>
        <vxe-table-column field="subAcc" title="子账户账号"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page1.currentPage"
          :page-size.sync="page1.pageSize"
          :total="page1.totalResult"
          @page-change="changePage1"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable2"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="personalData"
          @current-change="currentChangeEvent2"
      >
        <vxe-table-column field="busiSubjectName" title="所属公司"></vxe-table-column>
<!--        <vxe-table-column field="subjectName" title="客户名称"></vxe-table-column>-->
        <vxe-table-column field="memName" title="子账户户名"></vxe-table-column>
        <vxe-table-column field="subAcc" title="子账户账号"></vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>
    <vxe-modal
        v-model="isShowAddModal"
        :title="modalTitle"
        width="600"
        height="550"
        transfer
        resize
    >
      <div>
        <vxe-form
            ref="xForm"
            class="my-form2"
            title-align="right"
            title-width="150"
            :data="formData"
            :rules="formRules"
            @submit="submitEvent"
            @reset="cancelEvent"
        >
          <vxe-form-item title="所属公司" field="busiSubjectName" span="24">
            <template>
              <vxe-pulldown ref="companyDown" transfer>
                <template v-slot>
                  <div
                      class="sel-link-text"
                      @click="focusEvent('companyDown')"
                      target="_black"
                      style="cursor: pointer; display: inline-block; width: 100%; text-algin: center"
                  >
                    {{ formData.busiSubjectName ? formData.busiSubjectName : "请选择所属公司" }}
                    <i class="vxe-input--suffix-icon fa vxe-icon--arrow-bottom"></i>
                  </div>
                </template>
                <template v-slot:dropdown>
                  <div class="company-dropdown4">
                    <Input
                        search
                        suffix="ios-search"
                        v-model="searchName"
                        placeholder
                        @keyup.enter.native="search1"
                        @on-search="search1"
                        style="width: 200px"
                    />
                    <vxe-grid
                        highlight-hover-row
                        auto-resize
                        height="auto"
                        :loading="loading"
                        :pager-config="tablePage"
                        :data="tableData"
                        :columns="tableColumn"
                        @cell-click="cellClickEvent"
                        @page-change="pageChange"
                    >
                    </vxe-grid>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
            <!-- <template v-if="type == 1">
              {{ formData.busiSubjectName ? formData.busiSubjectName : "请选择所属公司" }}
            </template> -->
          </vxe-form-item>
          <vxe-form-item
              title="统一社会信用代码"
              field="identiNum"
              span="24"
              v-if="account && account.userType === 2"
          >
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.identiNum"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>

          <vxe-form-item
              title="法人姓名"
              field="realname"
              span="24"
              v-if="account && account.userType === 2"
          >
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.realname"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="姓名"
              field="realname"
              span="24"
              v-if="account && account.userType === 1"
          >
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.realname"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="法人身份证号码"
              field="idno"
              span="24"
              v-if="account && account.userType === 2"
          >
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.idno"
                  placeholder=""
                  clearable
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="身份证号码"
              field="identiNum"
              span="24"
              v-if="account && account.userType === 1"
          >
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.identiNum"
                  placeholder="请输入身份证号码"
                  clearable
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="结算账户" field="bindAccName" span="24">
            <template>
              <vxe-pulldown ref="accDown" transfer>
                <template v-slot>
                  <div
                      class="sel-link-text"
                      @click="focusEvent('accDown')"
                      target="_black"
                      style="cursor: pointer; display: inline-block; width: 100%; text-algin: center"
                  >
                    {{ formData.bindAccName ? formData.bindAccName : "请选择结算账户" }}
                    <i class="vxe-input--suffix-icon fa vxe-icon--arrow-bottom"></i>
                  </div>
                </template>
                <template v-slot:dropdown>
                  <div class="company-dropdown4">
                    <vxe-grid
                        highlight-hover-row
                        auto-resize
                        height="auto"
                        :loading="loading"
                        :data="accTableData"
                        :columns="accTableColumn"
                        empty-text="没有更多数据了！"
                        @cell-click="accCellClickEvent"
                    >
                      <template v-slot:empty>
                        <span style="color: #2d8cf0">
                          <p>请先添加银行账户</p>
                        </span>
                      </template>
                    </vxe-grid>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
          </vxe-form-item>
          <vxe-form-item title="结算银行账号" field="bindAccNum" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.bindAccNum"
                  placeholder="请选择结算账户"
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="结算开户银行" field="bindOpenBankName" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.bindOpenBankName"
                  placeholder="请选择结算账户"
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <!-- <vxe-form-item title="是否跨行" field="isCrossLine" span="24">
            <template v-slot>
              <vxe-radio-group v-model="formData.isCrossLine">
                <vxe-radio label="02">是</vxe-radio>
                <vxe-radio label="01">否</vxe-radio>
              </vxe-radio-group>
            </template>
          </vxe-form-item> -->
          <vxe-form-item align="center" span="24">
            <template v-slot>
              <vxe-button type="submit" status="primary">确定</vxe-button>
              <vxe-button type="reset">取消</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </div>
    </vxe-modal>
    <vxe-modal
        title="新增银行账户"
        v-model="createAccountModal"
        width="600"
        height="380"
        position="center"
        transfer
        destroy-on-close
        @close="closeAddAccount"
    >
      <add-bank-account
          ref="addBankAccount"
          @close="closeAccount"
          :userId="userId"
          :userName="userName"
          @successData="getSuccessData"
      ></add-bank-account>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import {apiRequest} from "@/utils/api";
  import {isEmpty, isNotEmpty, showLoading, hideLoading} from "@/utils/util";
  import addBankAccount from "@/views/account/addBankAccount";

  export default {
    name: "Account",
    components: {addBankAccount},
    data() {
      const identiNumValidator = ({itemValue}) => {
        if (itemValue && itemValue !== "" && this.account && this.account.userType === 1) {
          if (itemValue.length !== 18) {
            return Promise.reject(new Error("请输入正确的身份证号！"));
          }
        }
      };
      return {
        loading: false,
        selectTab: "tab1",
        username: null,
        companyData: [],
        personalData: [],
        page1: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        page2: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        initObj: null,
        index: null,
        field: null,
        clientname: null,
        isShowAddModal: false,
        modalTitle: "开通子账户",
        formData: {
          realname: null, // 法人姓名
          idno: null, // 法人身份证号码
          identiNum: null, // 统一社会信用代码
          bindAccName: null, // 结算账户
          bindAccNum: null, // 结算银行账号
          busiSubjectName: null, // 公司名称
          subjectId: null, // 平台公司id
          bindOpenBankName: null, // 结算开户银行
          bindOpenOrgNum: null,
          isCrossLine: "02",
          phoneNumber: null,
        },
        formRules: {
          realname: [{required: true, message: "请输入姓名"}],
          // idno: [{required: true, message: "请输入身份证号码"}, { max: 18, min: 18, message: "请输入正确的身份证号码"}],
          identiNum: [
            {required: false, message: "请输入身份证号码"},
            {validator: identiNumValidator},
          ],
          bindAccName: [{required: true, message: "请选择结算账户"}],
          bindAccNum: [{required: true, message: "请输入银行账号"}],
          busiSubjectName: [{required: true, message: "请选择公司名称"}],
          bindOpenBankName: [{required: true, message: "请输入结算开户银行"}],
          isCrossLine: [{required: true, message: "请选择是否跨行"}],
        },
        account: null,
        searchName: "",
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          size: "mini",
        },
        tableData: [],
        tableColumn: [{field: "name", title: "公司名称"}],
        accTableData: [],
        accTableColumn: [
          {field: "accountNum", title: "账户号"},
          {field: "openBankName", title: "开户行"},
        ],
        createAccountModal: false,
        isPayProdureByEdit: false,
        ownSearch: false,
        isCollection: false,
        // compNameType: 0
      };
    },
    watch: {
      isShowAddModal(nv, ov) {
        if (!nv && ov) {
          this.resetFormData();
        }
      },
      // compNameType: {
      //   deep: true,
      //   immediate: true,
      //   handler: function (val, oldVal) {
      //     if (val === 1) {
      //       this.selectTab = "tab1"
      //     }
      //   },
      // },
      //resetFormData
    },
    computed: {
      userId() {
        return this.account ? this.account.id : null;
      },
      userName() {
        return this.account
          ? this.account.userType === 2
            ? this.account.compName
            : this.account.realName
          : null;
      },
    },
    created() {
    },
    methods: {
      getSuccessData(val) {
        console.log(val);
        if (val) {
          this.formData.bindAccName = val.accountName;
          this.formData.bindAccNum = val.accountNum;
          this.formData.bindOpenBankName = val.openBankName;
          this.formData.bindOpenOrgNum = val.openOrgNum;
        }
      },
      closeAddAccount() {
        this.$nextTick(() => {
          this.$refs.addBankAccount.cancelSubmit();
        });
      },
      closeAccount() {
        this.createAccountModal = false;
      },
      changePage1(e) {
        this.page1.currentPage = e.currentPage;
        this.page1.pageSize = e.pageSize;
        this.queryCompUserList();
      },
      changePage2(e) {
        this.page2.currentPage = e.currentPage;
        this.page2.pageSize = e.pageSize;
        this.queryPerUserList();
      },
      currentChangeEvent1({row}) {
        this.$emit("choose", row, this.index, this.field, 0);
      },
      currentChangeEvent2({row}) {
        this.$emit("choose", row, this.index, this.field, 1);
      },
      search1() {
        this.tablePage.currentPage = 1;
        this.getCompanyList();
      },
      cellClickEvent({row}) {
        this.formData.busiSubjectName = row.name;
        this.formData.busiSubjectId = row.id;
        this.formData.bindAccName = "请选择结算账户";
        this.formData.bindAccNum = null;
        this.$refs.companyDown.hidePanel();
        this.$refs.xForm.clearValidate("busiSubjectName");
      },
      search() {
        if (this.selectTab === "tab1") {
          // 搜索企业用户列表
          this.page1.currentPage = 1;
          this.page1.pageSize = 10;
          this.queryCompUserList();
        } else {
          this.page2.currentPage = 1;
          this.page2.pageSize = 10;
          this.queryPerUserList();
        }
      },
      oSearch() {
        this.ownSearch = true;
        if (this.selectTab === "tab1") {
          // 搜索企业用户列表
          this.page1.currentPage = 1;
          this.page1.pageSize = 10;
          this.queryCompUserList();
        } else {
          this.page2.currentPage = 1;
          this.page2.pageSize = 10;
          this.queryPerUserList();
        }
      },
      getDetail(id) {
        var data = {
          id: id,
        };
        new Promise((resolve, reject) => {
          $api.gcdUser.queryGcdUserModel
            .POST({
              data,
            })
            .then((response) => {
              if (response.data) {
                if (response.data.userType == 2) {
                  this.userType = 2;
                  this.formData.realname = response.data.realName;
                  this.formData.idno = response.data.idcardNum;
                  this.formData.identiNum = response.data.taxNum;
                  this.formData.identiType = "b";
                  this.formData.memType = 0;
                  this.formData.phoneNumber = response.data.phoneNum;
                } else {
                  this.userType = 1;
                  this.formData.realname = response.data.realName;
                  this.formData.idno = response.data.identiNum;
                  this.formData.identiNum = response.data.idcardNum;
                  this.formData.memType = 1;
                  this.formData.identiType = 1;
                  this.formData.phoneNumber = response.data.phoneNum;
                }
              }

              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });
      },
      init(obj, i, field, compNameType, account, payProdure) {
        this.ownSearch = false;
        console.log(obj, i, field, compNameType, account);
        this.isPayProdureByEdit = false
        if (field == "paymentsName") {
          this.selectTab = !compNameType ? "tab1" : "tab2"
        }

        if (field == "recName") {
          this.selectTab = obj.recBankOwn && obj.recBankOwn === obj.recName ? "tab1" : "tab2"
        }
        // this.selectTab = !compNameType || (obj.recBankOwn && obj.recBankOwn === obj.recName && field !== 'paymentsName') ? "tab1" : "tab2";
        // if (field === "paymentsName") {
        //   // compNameType === 0 或者 undefined
        //   this.selectTab = !compNameType ? "tab1" : "tab2";
        // } else {
        //   this.selectTab = "tab2";
        // }
        // this.selectTab = "tab1";
        this.username = null;
        this.clientname = null;
        this.page1.currentPage = 1;
        this.initObj = obj;
        this.index = i;
        this.field = field;
        this.account = account ? account : null;
        if (account && account.userType === 1) {
          this.formRules.identiNum[0].required = true;
        }
        // console.log(account, 'account');
        if (payProdure === 'payProdure') {
          this.isCollection = false;
          if (this.initObj.paymentsType === 1) {
            this.selectTab = 'tab2';
          }
        } else {
          this.isCollection = true;
          this.selectTab = field === "paymentsName" ? 'tab1' : 'tab2';
        }

        if (account) {
          this.getDetail(account.id);
        }
        // this.compNameType = compNameType
        // console.log(account);
        let haveAccount = field === "paymentsName" ? obj.payAccountObj : obj.recAccountObj;
        // 如果流程编辑 不知道账户
        if (!haveAccount && obj.recBankOwn !== obj.recName) {
          this.isPayProdureByEdit = true
        }
        this.queryPerUserList();
        this.queryCompUserList();
      },
      async queryPerUserList() {
        this.loading = true;
        let path = "api/finance/";
        let action = "cebBusiMem/queryMemList";

        let subjectName = this.clientname ? this.clientname : this.field !== "paymentsName" ? this.initObj.clientName : this.clientname;
        let subjectId = this.userId;
        let memName = isNotEmpty(this.username) ? this.username : null;
        if (isNotEmpty(memName)) {
          subjectName = null;
        }
        // console.log(this.account, 'this.account');
        // let busiSubjectId =
        //   isNotEmpty(this.initObj) && isNotEmpty(this.initObj.payBank)
        //     ? this.initObj.platformCompanyId
        //       ? this.initObj.platformCompanyId
        //       : this.initObj.payBankAccountId
        //     : null;
        // console.log(this.initObj, 'this.initObj');
        let busiSubjectName = this.initObj.compName;
        let busiSubjectId = this.initObj.platformCompanyId;

        let params = {
          memName,
          subjectId: this.field !== "paymentsName" ? subjectId : null,
          subjectName,
          busiSubjectId,
          busiSubjectName,
          page: this.page2.currentPage,
          rows: this.page2.pageSize,
          subjectType: 1,
          orderBy: 2,
        };


        if (this.ownSearch) {
          params.subjectId = null;
          params.busiSubjectName = null;
          params.busiSubjectId = null;
        }

        let res = await apiRequest(path, action, params);
        this.loading = false;
        if (res.status === 1) {
          this.page2.totalResult = res.data.total;
          this.personalData = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      resetFormData() {
        this.formData.busiSubjectName = null;
        this.formData.subjectId = null;
        this.formData.bindAccName = null;
        this.formData.bindAccNum = null;
        this.formData.bindOpenBankName = null;
        this.formData.bindOpenOrgNum = null;
      },
      createUser() {
        this.isShowAddModal = true;
        if (this.$refs.xForm) {
          this.$refs.xForm.clearValidate();
        }
        this.formData.subjectId = this.account.id;
        if (this.account.userType === 2) {
          this.formData.realname = this.account.realName;
          this.formData.idno = this.account.idcardNum;
          this.formData.identiNum = this.account.taxNum;
        } else if (this.account.userType === 1) {
          this.formData.realname = this.account.realName;
          this.formData.identiNum = this.account.idcardNum;
        }
      },
      submitEvent() {
        let self = this;
        // 提交
        let txt = this.type === 0 ? "添加成功！" : "修改成功！";
        // 提交
        let memType = this.account.userType === 2 ? 0 : 1;
        let obj = {
          subjectType: 1,
          subjectId: this.formData.subjectId,
          subjectName: this.userName,
          identiNum: this.formData.identiNum,
          realname: this.formData.realname,
          idno: this.formData.idno,
          bindAccName: this.formData.bindAccName,
          bindAccNum: this.formData.bindAccNum,
          bindOpenBank: this.formData.bindOpenBank,
          bindOpenOrgNum: this.formData.bindOpenOrgNum,
          bindOpenBankName: this.formData.bindOpenBankName,
          busiSubjectId: this.formData.busiSubjectId,
          busiSubjectName: this.formData.busiSubjectName,
          isCrossLine: this.formData.isCrossLine,
          identiType: this.formData.identiType,
          memType,
          phoneNumber: this.formData.phoneNumber,
        };
        if (this.formData.isCrossLine == "01") {
          obj.bindOpenOrgNum == null;
        }
        showLoading();
        $api.finance.createMemModel
          .POST({
            data: obj,
          })
          .then((res) => {
            hideLoading();
            if (res.status === 1) {
              this.$XModal.message({message: txt});
              this.isShowAddModal = false;
              this.queryPerUserList();
              // this.queryUserListByObj(this.paramsObj);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error",
              });
            }
          })
          .catch(function (er) {
            hideLoading();
            console.log(er.response.data.message);
            self.$XModal.alert({
              message: er.response.data.message ? er.response.data.message : "接口异常",
              status: "error",
            });
            return;
          });
      },
      cancelEvent() {
        this.isShowAddModal = false;
      },
      focusEvent(name) {
        let refs = this.$refs[name];
        refs.showPanel();
        this.searchName = null;
        this.tablePage = {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          size: "mini",
        };
        switch (name) {
          case "companyDown":
            this.getCompanyList();
            break;
          case "accDown":
            this.getPlatformCorp();
        }
        this.$refs.xForm.clearValidate("bindAccName");
      },
      async getCompanyList() {
        let params = {
          orderBy: 2,
          page: this.tablePage.currentPage,
          rows: this.tablePage.pageSize,
        };
        if (!isEmpty(this.searchName)) {
          params.name = this.searchName;
        }
        if (isEmpty(this.tableData)) {
          this.loading = true;
        }
        let res = await $api.finance.post("cebBusiMem/queryCompanyWithBusi", params);
        this.loading = false;
        if (res.status === 1) {
          this.tableData = res.data.rows;
          this.tablePage.total = res.data.total;
        }
      },
      pageChange(e) {
        this.tablePage.currentPage = e.currentPage;
        this.tablePage.pageSize = e.pageSize;
        this.getCompanyList();
      },
      async getPlatformCorp() {
        let res = await $api.baseUserSignBank.request("queryUserBankList", {
          userId: this.userId,
          accountName: this.userName,
        });
        this.accTableData = res.data;
        if (isEmpty(this.accTableData)) {
          this.$XModal.confirm("请先添加银行账户").then((type) => {
            if (type === "confirm") {
              this.createAccountModal = true;
              this.$nextTick(() => {
                this.$refs.addBankAccount.init();
              });
            }
          });
        }
      },
      async queryCompUserList() {
        this.loading = true;
        let path = "api/finance/";
        let action = "cebBusiMem/queryMemList";
        let memName = isNotEmpty(this.username)
          ? this.username
          : isNotEmpty(this.initObj)
            ? this.field == "paymentsName"
              ? this.initObj.compName
              : this.initObj.clientName
            : null;
        let params = {
          memName: this.field === 'paymentsName' ? memName : this.ownSearch ? memName : null,
          page: this.page1.currentPage,
          rows: this.page1.pageSize,
          subjectType: 0,
          orderBy: 2,
        };
        let res = await apiRequest(path, action, params);
        this.loading = false;
        if (res.status === 1) {
          this.page1.totalResult = res.data.total;
          this.companyData = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      accPageChange() {
      },
      accCellClickEvent({row}) {
        this.formData.bindAccName = row.accountName;
        this.formData.bindAccNum = row.accountNum;
        this.formData.bindOpenBankName = row.openBankName;
        this.formData.bindOpenOrgNum = row.openOrgNum;
        this.$refs.accDown.hidePanel();
      },
      close() {
        this.selectTab = "tab1";
        this.username = null;
        this.page1 = {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        };
        this.page2 = {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        };
        this.$refs.xTable1.clearCurrentRow();
        this.$refs.xTable2.clearCurrentRow();
      },
    },
  };
</script>

<style scoped>
  .search-right-btn {
    display: inline-block;
    vertical-align: middle;
    margin: -3px 0 0 10px;
  }

  .my-form2 .vxe-pulldown {
    width: 100%;
  }

  .my-form2 .sel-link-text {
    border: 1px solid #dcdfe6;
    width: 100%;
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    text-indent: 8px;
    color: #2d8cf0;
    position: relative;
  }

  .my-form2 .sel-link-text .vxe-icon--arrow-bottom {
    color: #999;
    position: absolute;
    right: 10px;
    top: 8px;
  }

  .company-dropdown4 {
    width: 400px;
    height: 300px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
    position: relative;
  }

  .company-dropdown4 .ivu-input-wrapper {
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 999;
  }

  .company-dropdown4 .ivu-input {
    border-radius: 0;
  }
</style>
